import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";

const PromptLocalWithholdingsUponUpload = ({
  show,
  onConfirm,
  onCancel,
}: any) => {
  return (
    <Modal
      disableAutoFocus
      open={show}
      onClose={() => onCancel()}
      aria-labelledby="confirm-w2-modal"
      className={"modal-container"}
    >
      <div className={"modal-paper"}>
        <Box component="h3" m={1} className={"modal-title"}>
          Missing local withholdings
        </Box>
        <p className={"modal-sub-title"}>
          LIME didn’t find any local wage/withholding information in boxes 18,
          19 or 20 of your W-2. Please take a look at the W-2 now. If boxes 18,
          19 and 20 are empty, select “Continue.” If there is information in
          those boxes, select “Edit” to enter the local wage, withholding, and
          city information from your W-2.
        </p>
        <Box className={"modal-button-container"}>
          <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"Edit"}
            onClick={() => onCancel()}
            buttonSize={"modal-button-left"}
          />
          <CustomButton
            variant="contained"
            disableElevation={true}
            label={"Continue"}
            onClick={() => onConfirm()}
          />
        </Box>
      </div>
    </Modal>
  );
};

export default PromptLocalWithholdingsUponUpload;
